import React, { useContext, useState } from "react";
import { Input } from "@/app/components/ui/input";
import { Flex } from "@radix-ui/themes";
import { SearchIcon, XIcon } from "lucide-react";
import { AuctionFilterContext } from "@/lib/context/AuctionFilterContext";

interface AuctionSearchProps {}

const AuctionSearch = ({}: AuctionSearchProps) => {
  const auctionFilterContext = useContext(AuctionFilterContext);

  return (
    <Flex className="w-full sm:w-[400px] relative">
      <Flex className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-500">
        <SearchIcon className="w-4 h-4 text-slate-400" />
      </Flex>
      <Input
        value={auctionFilterContext?.search}
        className="max-w-[400px] pl-10 h-10"
        placeholder="Search number, title, description, or category..."
        onChange={(e) => auctionFilterContext?.setSearch(e.target.value)}
      />
      {auctionFilterContext?.search && (
        <button
          onClick={() => auctionFilterContext?.setSearch("")}
          className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700"
        >
          <XIcon className="w-4 h-4" />
        </button>
      )}
    </Flex>
  );
};

export default AuctionSearch;
